import escapeRegExp from 'lodash/escapeRegExp';
import { fg } from '@atlassian/jira-feature-gating';
import { quoteString } from './quote-string.tsx';

// Check if string have inner spaces
const haveSpaces = (s: string) => /\s/g.test(s.trim());

// Mirrors sanitzation in JQL AST package
const CHARS_TO_QUOTE = new RegExp(`[\\s${escapeRegExp('"\'=!<>()~,[]|&{}*/%+^$#@?;')}]`);

// Sanitization method mirrors JQL AST with addition of setting to lowercase
export const sanitizeClauseName = (clauseName: string) => {
	if (
		fg('jsc_list_reranking_ast_refactor')
			? CHARS_TO_QUOTE.test(clauseName.trim())
			: haveSpaces(clauseName)
	) {
		return quoteString(clauseName);
	}

	return clauseName;
};
